import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function updateCartItem(token: string, item_id: string, dealer_markup: number, applied_discount: number, qty: number): Promise<[]> {
  return new AxiosRequestSender(client)
    .setUrl('updateCartItem')
    .setMethod('POST')
    .setProps([{token: token, item_id: item_id, dealer_markup: dealer_markup, applied_discount: applied_discount, qty: qty}])
    .send();
}
export async function itemUpdateQuoteId(token: string, item_ids: string[], new_quote_id: string): Promise<[]> {
  return new AxiosRequestSender(client)
    .setUrl('itemUpdateQuoteId')
    .setMethod('POST')
    .setProps([{token: token, item_ids: item_ids, new_quote_id: new_quote_id}])
    .send();
}